// src/pages/auth/ForgotPassword.tsx

import React from 'react';
import { Formik, Form } from 'formik';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import styles from './../login/Login.module.css';
import { FormikTextField } from '../../components/form-components/common-components/text-field/FormikTextField';
import * as Yup from 'yup';
import { useStore } from '../../hooks/useStore';
import { Box } from '@mui/material';
import KaldenLogo from '../../assets/kalden-logo.png';

// 1) Form validasyonu (Yup şeması)
const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email('Geçerli bir e-posta adresi giriniz')
    .required('E-posta adresi zorunlu'),
});

export const ForgotPassword: React.FC = () => {
  const { authStore } = useStore();
  const navigate = useNavigate();

  const handleSubmit = async (values: { email: string }) => {
    try {
      const response: any = await authStore.forgotPassword({ email: values.email });

      if (response.error) {
        toast.error(response.message || 'Şifre sıfırlama linki gönderilemedi');
        return;
      }

      toast.success(response.message || 'Şifre sıfırlama linki e-posta adresinize gönderildi.');
    } catch (error) {
      console.error(error);
      toast.error('Şifre sıfırlama işlemi sırasında bir hata oluştu');
    }
  };

  return (
    <div className={styles.container}>
      <img src={KaldenLogo} alt="Kalden Logo" className={styles.logo} />
      <div className={styles.formWrapper}>
        <h1 className={styles.title}>Şifre Sıfırlama</h1>
        <Formik
          initialValues={{ email: '' }}
          validationSchema={ForgotPasswordSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className={styles.form}>
              <FormikTextField
                name="email"
                label="E-posta Adresi"
                type="email"
                placeholder="E-posta adresinizi giriniz"
              />

              <Box sx={{ mb: 2 }} />

              <button type="submit" className={styles.submitButton} disabled={isSubmitting}>
                {isSubmitting ? 'Gönderiliyor...' : 'Sıfırlama Linki Gönder'}
              </button>

              <div className={styles.registerLink}>
                <Link to="/login">Giriş Sayfasına Dön</Link>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};
